module.exports = __webpack_public_path__ + "static/media/logo.752fb8cf.svg";